import { GIT_COMMIT_HASH } from '@/define/env';
/**
 * 仕様変更後で値が変わった場合でも既存Storageを参照して古いデータを表示しないようにするため、
 * コミットバージョンに応じたキーを返す
 *
 * @param key SessionStorageのキー
 */
const getSessionStorageKey = (key) => `${GIT_COMMIT_HASH || 'localhost'}-${key}`;
/** session storage key: TOP のセミナー一覧データ */
export const SESSION_STORAGE_KEY_TOP_SEMINAR_LIST = getSessionStorageKey('top-seminar-list-key');
/** session storage key: TOP のコラム一覧データ */
export const SESSION_STORAGE_KEY_TOP_COLUMN_LIST = getSessionStorageKey('top-column-list-key');
/** session storage key: TOP のテーマ一覧データ */
export const SESSION_STORAGE_KEY_TOP_THEME_LIST = getSessionStorageKey('top-theme-list-key');
/** session storage key: TOP の選定支援事例一覧データ */
export const SESSION_STORAGE_KEY_TOP_CASE_LIST = getSessionStorageKey('top-case-list-key');
/** session storage key: ニュース 一覧データ */
export const SESSION_STORAGE_KEY_RELEASE_LIST = getSessionStorageKey('release-list-key');
/** session storage key: ニュース 詳細データ */
export const SESSION_STORAGE_KEY_RELEASE_ONE = getSessionStorageKey('release-one-key');
/** session storage key: 選定支援事例 詳細 */
export const SESSION_STORAGE_KEY_CASE_ONE = getSessionStorageKey('case-one-key');
/** session storage key: カテゴリー 選定支援事例 */
export const SESSION_STORAGE_KEY_CATEGORY_CASE = getSessionStorageKey('category-case-key');
/** session storage key: カテゴリー コラム */
export const SESSION_STORAGE_KEY_CATEGORY_COLUMN = getSessionStorageKey('category-column-key');
/** session storage key: カテゴリー セミナー */
export const SESSION_STORAGE_KEY_CATEGORY_SEMINAR = getSessionStorageKey('category-seminar-key');
/** session storage key: 記事一覧ページの件数一覧 */
export const SESSION_STORAGE_KEY_ARTICLE_COUNT = getSessionStorageKey('article-count-key');
/** session storage key: 人気記事 一覧 */
export const SESSION_STORAGE_KEY_POPULAR_LIST_ARTICLE = getSessionStorageKey('release-popular-list-article');
/** session storage key: 人気コンサルタント 一覧 */
export const SESSION_STORAGE_KEY_POPULAR_LIST_PROFESSIONAL = getSessionStorageKey('release-popular-list-professional');
/** session storage key: 人気選定支援事例 一覧 */
export const SESSION_STORAGE_KEY_POPULAR_LIST_CASE = getSessionStorageKey('release-popular-list-case');
